import * as types from '../actionType'

const initialState = []

const homePage = (state = initialState, action) => {
    switch (action.type) {
        case types.HOME_DATA:
            return action.payload
        default:
            return state
    }
}

export {homePage};
